import {
  DESKTOP_PREVIEW_HEIGHT,
  DESKTOP_PREVIEW_HEIGHT_COMPACT,
  DESKTOP_PREVIEW_WIDTH,
  DESKTOP_PREVIEW_WIDTH_COMPACT,
} from '../constants';

export interface IDesktopPreviewSize {
  width: number;
  height: number;
}

export function getDesktopPreviewSize(isCompact: boolean): IDesktopPreviewSize {
  if (isCompact) {
    return { width: DESKTOP_PREVIEW_WIDTH_COMPACT, height: DESKTOP_PREVIEW_HEIGHT_COMPACT };
  }

  return { width: DESKTOP_PREVIEW_WIDTH, height: DESKTOP_PREVIEW_HEIGHT };
}
